import { Box, CircularProgress } from '@mui/material';
import { Suspense } from 'react';
import { useMobileView } from 'utils/customHooks';

const ResponsiveContainer = ({ Mobile, Desktop }) => {
	const showMobile = useMobileView();

	return (
		<Suspense
			fallback={
				<Box
					sx={{
						height: '100%',
						width: '100%',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center'
					}}
				>
					<CircularProgress />
				</Box>
			}
		>
			{showMobile ? <Mobile /> : <Desktop />}
		</Suspense>
	);
};

export default ResponsiveContainer;
